import React, { FunctionComponent } from "react";
import styles from "./BackgroundImage.module.scss";
import BackgroundImageProps from "./BackgroundImageProps.interface";

import combineClasses from "helpers/combine-classes";
import ImageViewer from "components/ImageViewer/ImageViewer";
import useWrapperStyles from "./hooks/useWrapperStyles";

const BackgroundImage: FunctionComponent<BackgroundImageProps> = (props): JSX.Element => {
    const wrapperStylesElementRef = useWrapperStyles(props);

    return (
        <div className={combineClasses(styles.wrapper, props.className)} ref={wrapperStylesElementRef}>
            {/* Media */}
            {/* TODO: Dont show overlay until image is loaded */}
            {props?.content?.image && props.content.image?.umbracoFile ? (
                <ImageViewer key={props?.content.image.umbracoFile.src} className={styles.image} src={props?.content.image.umbracoFile.src} focalPoint={props.content.image.umbracoFile.focalPoint} alt={props.content.backgroundImageAlternative}/>
            ) : null}
        </div>
    );
};

export default BackgroundImage;